// Downscale a picked image to a JPEG whose longest edge is at most `maxEdge`,
// before upload. Cuts Supabase Storage egress + storage (the browser otherwise
// uploads the full-resolution original). Best-effort: on any failure (decode
// error, no canvas) it returns the original file untouched.
export async function resizeImageFile(
  file: File,
  maxEdge = 1600,
  quality = 0.7,
): Promise<Blob> {
  try {
    const bitmap = await createImageBitmap(file);
    const longer = Math.max(bitmap.width, bitmap.height);
    const scale = Math.min(1, maxEdge / longer); // never upscale
    const w = Math.round(bitmap.width * scale);
    const h = Math.round(bitmap.height * scale);

    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) return file;
    ctx.drawImage(bitmap, 0, 0, w, h);
    bitmap.close?.();

    const blob = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, "image/jpeg", quality),
    );
    return blob ?? file;
  } catch {
    return file;
  }
}
